export default {

  // landings

  getStarted: 'Get started',

  // site

  pageVisit: {
    productPage: 'Product page',
    productOfTheMonthPage: 'Product of the month page',
  },

  signup: 'Signup',
  registerEmailAlreadyExists: 'Register email already exists',
  welcomeSkip: 'Welcome skip',
  pickPage: {
    skip: 'Pick page skip',
    addProduct: 'Pick page add product',
    bannerClick: 'Pick page banner click',
    categoryFilter: 'Pick page category filter',
  },
  addressValidationPopup: {
    open: 'Address validation popup',
    useAddress: 'Address validation use address',
    editAddress: 'Address validation edit address',
  },
  appStore: {
    badgeClick: 'App Store badge click',
    bannerClick: 'App Store banner click',
    banner: 'App Store banner',
  },
  googlePlay: {
    badgeClick: 'GooglePlay badge click',
  },
  linkToLogin: 'Link to login',
  casesBannerClick: 'Cases banner click',
  buyNow: 'Buy now',
  cardUpdateBannerClick: 'Card update banner click',
  cardUpdatePopup: 'Card update popup',
  burgerMenuClick: 'Burger menu click',
  burgerMenuLinkClick: 'Burger menu link click',
  burgerMenuInsideClick: 'Burger menu inside click',
  footerLinkClick: 'Footer link click',
  profileMenuClick: 'Profile menu click',
  desktopProfileMenuClick: 'Profile menu',
  paypalUpdateBannerClick: 'Paypal update banner click',
  paypalUpdateClick: 'Paypal update click',
  writeReviewClick: 'Write review click',
  subscribeNowLinkClick: 'Subscribe now link click',
  orderStatusLinkClick: 'Order status link click',
  productsInQueueLinkClick: 'Products in queue link click',
  ratedProductsLinkClick: 'Rated products link click',
  reviewsWrittenLinkClick: 'Reviews written link click',
  trackingNumberClick: 'Tracking number click',
  collectionAddToQueueAllButton: 'Collection add to queue all button',
  addToQueue: 'Add to queue front',
  addToCart: 'Add to cart',
  searchInputClick: 'Search input click',
  buyGiftSubscriptionClick: 'Buy gift subscription click',
  buyGiftSubscriptionStepComplete: 'Buy gift subscription step complete',
  giftSelect: 'Gift select',
  buyGiftCardClick: 'Buy gift card click',
  buyGiftCardStepComplete: 'Buy gift card step complete',
  navigationMenuClick: 'Navigation menu click',
  quickViewClick: 'Quick view click',
  quizStepComplete: 'Quiz step complete',
  smartSearchTagClick: 'Smart search tag click',
  editReviewClick: 'Edit review click',
  shareButtonClick: 'Share button click',
  cancelSubscriptionClick: 'Cancel subscription click',
  cancelSubscriptionStepComplete: 'Cancel subscription step complete',
  resubscribeClick: 'Resubscribe click',
  upgradeSubscriptionClick: 'Upgrade subscription click',
  subscriptionUnpausePopup: 'Subscription unpause popup',
  optOutPremiumPopup: 'Opt out premium popup',
  premiumProductDescriptionClick: 'Premium product description click',
  thankYouQueuePopup: 'Thank you queue popup',
  thankYouQueuePopupClick: 'Thank you queue popup click',
  search: {
    bestsellersClick: 'Search bestsellers click',
    brandClick: 'Search brand click',
    brandUnavailableClick: 'Search brand unavailable click',
    noteClick: 'Search note click',
    pageClick: 'Search page click',
    cancel: 'Search cancel',
    nameClick: 'Search name click',
    nameUnavailableClick: 'Search name unavailable click',
    suggestionClick: 'Search suggestion click',
    query: 'Search query',
  },
  payment: {
    firstProductEditClick: 'First product edit click',
    firstProductChange: 'First product change',
  },
  queueProductRemove: 'Queue product remove',
  queueProductMove: 'Queue product move',
  sameProductPopup: 'Same product popup',
  cartClick: 'Cart click',

  recommendedProductView: 'Recommended product view',

  mainPageLoginClick: 'Main page login click',

  mobileMenuFirstClick: 'Mobile menu first click',

  promote: { // SB-121
    buyQueue: 'Buy queue click',
    casesBanner: 'Cases banner click',
    subscriptionUpgrade: 'Subscription upgrade click',
  },

  productCard: {
    readMoreClick: 'Read more click',
    seeDetailsClick: 'See details click',
  },

  mainPagePopularNotesClick: 'Main page note select', // SB-168
  noteProductsPage: 'Filter note results page', // SB-168

  collectionForSale: {  // SB-164
    visit: 'Collection set page',
    continueClick: 'Collection set continue click',
    collections: 'Collections set page',
    coverClick: 'Collection set cover click',
  },

  upgradePrepaidPlansPage: {   // SB-212
    visit: 'Prepaid plans page',
    upgradeOptionClick: 'Prepaid plan select',
  },

  collectionPage: 'Collection page', // SB-374

  unsubscribeReasonsPopup: { // SB-395
    open: 'Unsubscribe reasons popup',
    close: 'Unsubscribe reasons exit',
  },

  tasteMakerPage: { // SB-379
    visit: 'Tastemakers page',
  },

  fragranceFilterClick: 'Fragrance filter click', // SB-658

  productRatingSelect: 'Product rating select', // SB-405
  lowRatingReasonSelect: 'Low rating reason select', // SB-405
  reviewSubmitNotification: 'Review submit notification', // SB-405
  wellness: { // SB-412
    root: 'Wellness page',
  },

  newArrivals: 'New arrivals page', // SB-369

  recommendations: { // SB-398
    navigationLinkClick: 'Recs navigation link click',
    emptyStateBannerClick: 'Recs empty state banner click',
    visitRoot: 'Recs page',
    visitHistory: 'Recs history page',
    visitQuiz: 'Recs quiz page',
    visitSelections: 'Recs selections page',
  },

  filters: { // SB-854
    rating: 'Filter rating',
    type: 'Filter type name select',
    brand: 'Filter brand name select',
    note: 'Filter note name select',
  },

  // SB-816
  editAddressClick: 'Edit address link click',
  editQueueClick: 'Edit queue link click',
  retakeQuizClick: 'Retake quiz click',

  blackfridayBannerClick: 'Blackfriday banner click', // SB-874

  saveOnboardingProductCategoriesClick: 'Preferred categories select', // SB-971

  getTheMostPage: { // SB-223
    cardClick: 'Feature card click',
    visit: 'Get the most page',
  },

  countdownBannerClick: 'Countdown banner click', // SB-1050

  profilePage: 'Profile page', // SB-957

  stories: {
    view: 'Story view',
    click: 'Story click',
    action: 'Story action',
  },

  oneStepCancelSubscriptionModal: { // SB-1074
    open: 'Unsubscribe popup',
    click: 'Unsubscribe popup button click',
  },

  selectionsPrototype: { // SB-1256 not for production
    visitResults: 'Selections prototype results page',
    visitVote: 'Selections prototype vote page',
    changePreferencesClick: 'Selections prototype change preferences click',
    submit: 'Selections prototype submit',
    searchClick: 'Selections prototype search click',
    brandSelect: 'Selections prototype brand select',
    productSelect: 'Selections prototype product select',
    loadMoreClick: 'Selections prototype load more',
  },

  verifyShippingAddressPopup: { // SB-1219
    open: 'Shipping address verify popup',
    correctClick: 'Shipping address verify popup correct click',
    undeliverableOpen: 'Undeliverable address verify popup',
    undeliverableCorrectClick: 'Undeliverable address verify popup correct click',
    undeliverableLepOpen: 'Undeliverable address verify lep popup',
    undeliverableLepCorrectClick: 'Undeliverable address verify lep popup correct click',
  },

  productLikeClick: 'Product like click', // SB-1341
  productDislikeReasonClick: 'Product dislike reason click', // SB-1445
} as const
